export default "__VITE_ASSET__Cq5tKzf$__"